export default __webpack_public_path__ + "media/zurb/img/playground/moneybags-icon-001483208aa0a0436facd895f18815e0.svg";